import React from 'react';
import LoginSignupContent from "./loginSignupContent";
import {closeLoginModal} from "../user/currentUserActions";
import {connect} from "react-redux";

function LoginSignupModal({loginSignupModalTab, closeLoginModal}) {
  return (
    <div className="b-modal">
      <div className="login-signup-modal">
        <LoginSignupContent onSuccess={closeLoginModal} defaultTab={loginSignupModalTab}/>
      </div>
    </div>
  );
}

LoginSignupModal.propTypes = {
};

LoginSignupModal.defaultProps = {};

const mapDispatchToProps = {
  closeLoginModal,
};

function mapStateToProps(state) {
  return {
    loginSignupModalTab: state.currentUser.loginSignupModalTab,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginSignupModal);